import { ImageProps } from "./types";

export const Image = ({
  src,
  alt,
  width,
  height,
  className,
  loading = "lazy",
  dataTestId = "image",
}: ImageProps) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    decoding="async"
    loading={loading}
    className={className}
    data-test-id={dataTestId}
  />
);
